import { createContext, useContext } from "react";
import type { PlanColor } from "./_types";

type PlanContextType = {
  color: PlanColor;
}

export const PlanContext = createContext<PlanContextType | null>(null)

export function usePlan() {
  const ctx = useContext(PlanContext)

  if (!ctx) {
    throw new Error("Plan components must be used inside fucking Plan")
  }

  return ctx
}
